import React from 'react';
import styled from 'styled-components';

import BookIcon from '../assets/image/book.png';
import BaggageIcon from '../assets/image/baggage.png';
import PartnersIcon1 from '../assets/image/partners_1.png';
import PartnersIcon2 from '../assets/image/partners_2.png';
import PartnersIcon3 from '../assets/image/partners_3.png';
import PartnersIcon4 from '../assets/image/partners_4.png';
import { V2_ACTIVE_COLOR, V2_INACTIVE_COLOR } from '../config/color';

const ImageContainer = styled.p``;
const ContentsContainer = styled.section``;
const ContentsDesc = styled.div``;

const MainWrapper = styled.div`
  width: 100%;
  font-size: 0.8125rem;
  font-weight: 400;
  min-height: 100vh;
  padding-top: 60px;
  @media (max-width: 768px) {
    padding-top: 80px;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const MainSectionArticle = styled.div`
  width: 1440px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 0px;
  }
`;


const PartnersProgramContainer = styled.div`
  max-width: 800px;
  margin: 50px 0 60px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 768px) {
    margin: 30px 0 40px;
    padding: 0 20px;
  }

  ${ImageContainer} {
    width: 150px;
    @media (max-width: 768px) {
      width: 190px;
    }
  }

  h2 {
    font-size: 24px;
    font-weight: 400;
    margin: 20px 0 30px;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  ${ContentsContainer} {
    width: 100%;
    padding: 30px;
    text-align: center;
    line-height: 24px;
    background-color: white;
    border-radius: 16px;
  }
`

const PartnersProgramDesc = styled.div`
  max-width: 800px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 768px) {
    padding: 0 20px;
  }

  ${ImageContainer} {
    width: 180px;
    @media (max-width: 768px) {
      width: 200px;
    }
  }

  ${ContentsContainer} {
    width: 100%;
    padding: 60px 80px 50px;
    text-align: center;
    line-height: 24px;
    background: linear-gradient(0.25turn, #FEA989, #99B4DB);
    border-radius: 16px;
    position: relative;
    top: -60px;
    z-index: -1;
    @media (max-width: 768px) {
      padding: 60px 20px 50px;
    }
  }

  ${ContentsDesc} {
    width: 90%;
    padding: 20px 0px 40px;
    text-align: center;
    line-height: 24px;
    background: white;
    border-radius: 16px;
    position: relative;
    top: -95px;

    div {
      @media (max-width: 768px) {
        padding: 0 20px;
      }

      div {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        @media (max-width: 768px) {
          flex-direction: column;
        }

        div{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          flex: 1;
          margin-bottom: 40px;
          padding: 0 30px;
          @media (max-width: 768px) {
            padding: 0px;
          }

          &:is(:first-child) {
            border-right: 1px solid rgba(116, 143, 181, 0.4);
            @media (max-width: 768px) {
              border: none;
            }
          }

          ${ImageContainer} {
            width: 50px;
          }

          h3 {
            font-weight: 600;
            margin-bottom: 10px;
          }

        }
      }
      p {
        color: ${V2_INACTIVE_COLOR};
        span {
          display:inline-block;
          margin-bottom: 20px;
        }
      }
    }
  }
`

export default () => {
  return (
    <MainWrapper>
      <MainContainer>
        <MainSectionArticle>
          <PartnersProgramContainer>
            <ImageContainer>
              <img style={{width: '100%'}} src={BookIcon} />
            </ImageContainer>
            <h2>
              트레져러 파트너 프로그램
            </h2>
            <ContentsContainer>
              <p>
                최근 몇 년간 국내 시계 시장은 가파르게 성장해왔습니다.<br/>
                저희 트레져러는 명품 시계 시장의 유동성 공급과 성장을 돕고자 국내 및 해외 시계 거래 가격(크로노24, 일본 kakaku.com, 국내 거래 사이트 등)을 AI를 통해 분석하여 실시간으로 정확하게 거래가격을 예측하고 제시합니다.<br/>
                매일같이 변하는 세계의 중고 시계 가격 시세를 편리하고 빠르게 확인할 수 있습니다.<br/>
                현재 소수 지점에게 베타서비스를 오픈하여 무료로 시세를 제공하고 있으며, 아래 링크를 통하여 확인하실 수 있습니다.
              </p>
            </ContentsContainer>
          </PartnersProgramContainer>
          <PartnersProgramDesc>
            <ImageContainer>
              <img style={{width: '100%'}} src={BaggageIcon} />
            </ImageContainer>
            <ContentsContainer>
              <p>
                트레져러와 파트너 프로그램에 가입하시게 되면 <b>중고 시계 거래에 필요한 다양한 시세 데이터 및
                시장 분석 자료를 받아볼 수 있습니다.</b> 트레져러 파트너 프로그램은 빈티지 시계 유통에 필요한
                다양한 인프라를 지원할 계획이며, 현재 지원이 가능한 프로그램은 아래와 같습니다. 
              </p>
            </ContentsContainer>
            <ContentsDesc>
              <div>
                <div>
                  <div>
                    <ImageContainer>
                      <img style={{width: '100%'}} src={PartnersIcon1} />
                    </ImageContainer>
                    <h3>
                      판매물건 무료 홍보
                    </h3>
                    <p>
                      파트너로 등록된 점포에 한하여 한달에 약 30만명
                      방문하는 트레져러 홈페이지에 물품을 노출시켜,
                      파트너 웹사이트로 연결해 드립니다. 
                    </p>
                  </div>
                  <div>
                    <ImageContainer>
                      <img style={{width: '100%'}} src={PartnersIcon2} />
                    </ImageContainer>
                    <h3>
                      재고 담보 대출
                    </h3>
                    <p>
                      보유하고 있는 시계의 가치를 가장 잘 이해하는
                      금융회사는 대한민국에 트레져러 뿐입니다.
                      트레져러는 한정된 파트너에게 매우 낮은 이율로
                      최대 5억원까지 대출 지원을 하고 있습니다.
                    </p>
                  </div>
                </div>
                <div>
                  <div>
                    <ImageContainer>
                      <img style={{width: '100%'}} src={PartnersIcon3} />
                    </ImageContainer>
                    <h3>
                      시장 분석 자료
                    </h3>
                    <p>
                      연간 10만건 이상의 국내 거래 데이터를 기반으로
                      발행하는 상권 및 시장 분석 자료를 매 분기마다
                      파트너에게 제공해 드리고 있습니다.
                    </p>
                  </div>
                  <div>
                    <ImageContainer>
                      <img style={{width: '100%'}} src={PartnersIcon4} />
                    </ImageContainer>
                    <h3>
                      물품관리 시스템
                    </h3>
                    <p>
                      매장의 물품을 편리하게 관리할 수 있는
                      온라인 클라우드 시스템을 통해서,현재 매장에
                      소유하고 있는 재고를 관리 할 수 있을 뿐만 아니라,
                      실시간 시세를 관리할 수도 있습니다.
                    </p>
                  </div>
                </div>
                <p>
                  <span>
                    지금 파트너스에 회원가입을 하시면 무료로 모든 서비스를 이용하실 수 있습니다.<br/>감사합니다.
                  </span>
                </p>
                <p>
                  <span>
                    국내 최대 명품 시계 거래 플랫폼<br/>트레져러 드림
                  </span>
                </p>
              </div>
            </ContentsDesc>
          </PartnersProgramDesc>
        </MainSectionArticle>
      </MainContainer>
    </MainWrapper>
  )
}